import { NgModule } from '@angular/core';
import { DecimalDigitsDirective } from './directives/decimal-digits.directive';
import { InputTrimDirective } from './directives/input-trim.directive';
import { IntDigitsDirective } from './directives/int-digits.directive';
import { MaxInputValDirective } from './directives/max-val.directive';
import { MinInputValDirective } from './directives/min-val.directive';
import { PriceNumber } from './directives/price-number.directive';
import { ServerValidator } from './directives/server-validator.directive';
import { UpperHintDirective } from './directives/upper-hint.directive';
import { PostcodeFormatDirective } from './directives/postcode-format.directive';
import { LongPressDirective } from './directives/long-press.directive';
import { ChangedVisibilityDirective } from './directives/changed-visibility.directive';
import { OpenUrlDirective } from './directives/open-url-tab.directive';
import { RouteItineraryDottedLineIconDirective } from './directives/route-itinerary-dotted-line-icon.directive';

const directives = [
  InputTrimDirective,
  ServerValidator,
  PriceNumber,
  UpperHintDirective,
  DecimalDigitsDirective,
  MaxInputValDirective,
  MinInputValDirective,
  PostcodeFormatDirective,
  IntDigitsDirective,
  LongPressDirective,
  ChangedVisibilityDirective,
  OpenUrlDirective,
  RouteItineraryDottedLineIconDirective,
];

@NgModule({
  imports: [],
  declarations: [...directives],
  exports: [...directives],
})
export class VmeDirectivesModule {}
